import Repository from '@/repositories/repository'

const DividendCalendarRepository = {
  async getAllDividendCalendarData(queryParams: any = {}) {
    const params = {
      page: '1',
      page_size: '200',
      ...queryParams
    }

    return await Repository('dividend-calendar', 'page', params)
  }
}

export default DividendCalendarRepository
